(function ($, Drupal, once) {
  Drupal.behaviors.addRatesSelect = {
    attach: function (context, settings) {
      var heroes = once(
        "rates-select",
        ".paragraph--type--hero-band.paragraph--view-mode--rates",
        context
      );
      if (!heroes.length) return;
      var $hero = $(heroes);

      var $h1 = $hero.find("h1").first();
      if (!$h1.length) return;

      var $details = $("details", context);
      if (!$details.length) return;

      var $select = $('<select class="rates-select"></select>');
      $select.append('<option value="all">View All Rates</option>');

      $details.each(function (i) {
        var title = $(this).find("summary").first().text().trim();
        $select.append('<option value="' + i + '">' + title + "</option>");
      });

      var rateType = $(".rates-band--business", context).length
        ? "Business"
        : "Personal";
      var $label = $(
        '<label class="rates-select-label">Select ' +
          rateType +
          " Rate Type</label>"
      );

      $h1.after($select);
      $h1.after($label);

      $select.on("change", function () {
        var val = $(this).val();
        if (val === "all") {
          $details.show();
        } else {
          $details.hide();
          $details.eq(parseInt(val, 10)).show();
        }
      });

      window.addEventListener("resize", function () {
        if (window.innerWidth >= 1280) {
          $details.show();
          $select.val("all");
        }
      });
    },
  };
  Drupal.behaviors.ratesDetailsLock = {
    attach: function (context) {
      var details = once(
        "rates-details-lock",
        ".rates-band .paragraph--view-mode--rates details",
        context
      );
      if (!details.length) return;

      // Store closed state per element for restoring on resize down
      var closedSet = new WeakSet();

      details.forEach(function (el) {
        el.querySelector("summary").addEventListener("click", function (e) {
          if (window.innerWidth >= 1280) {
            e.preventDefault();
          }
        });
      });

      function handleResize() {
        var wide = window.innerWidth >= 1280;
        details.forEach(function (el) {
          if (wide) {
            if (!el.hasAttribute("open")) {
              closedSet.add(el);
            }
            el.setAttribute("open", "");
          } else {
            if (closedSet.has(el)) {
              el.removeAttribute("open");
              closedSet.delete(el);
            }
          }
        });
      }

      window.addEventListener("resize", handleResize);
      handleResize();
    },
  };
  Drupal.behaviors.ratesStackedTable = {
    attach: function (context) {
      var tables = once("rates-stacked", ".rates-band table", context);
      if (!tables.length) return;
      tables.forEach(function (table) {
        const isComparisonTable =
          table.dataset.parentViewMode == "comparison_table";

        if (!isComparisonTable) {
          var headers = [];
          var ths = table.querySelectorAll("thead th");
          ths.forEach(function (th) {
            headers.push(th.textContent.trim());
          });
          table.querySelectorAll("tbody tr").forEach(function (tr) {
            tr.querySelectorAll("td").forEach(function (td, i) {
              if (headers[i]) {
                td.setAttribute("data-label", headers[i]);
              }
            });
          });
        } else {
          table.querySelector("thead th.col_0").innerHTML =
            '<span class="visually-hidden">Product name</span>';
        }
      });
    },
  };
})(jQuery, Drupal, once);
